export default __webpack_public_path__ + "static/webRotator/svg/b0865d3bad1ddb7ee453019f7b7ab218.svg";